import { render, staticRenderFns } from "./BigList.vue?vue&type=template&id=3f66e74b&scoped=true&"
import script from "./BigList.vue?vue&type=script&lang=js&"
export * from "./BigList.vue?vue&type=script&lang=js&"
import style0 from "./BigList.vue?vue&type=style&index=0&id=3f66e74b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f66e74b",
  null
  
)

export default component.exports